import React, { useEffect, useState } from 'react';
import { PageComponentProps } from 'shared/interface/globalInterface';
import CommissionDetailsPage from '../../pages/CommissionDetailsPage/CommissionDetailsPage';
import { fetchProductsData, postCommissionDetails } from '../../api';
import { FormModel, Product } from 'modules/commission_terms/pages/CommissionDetailsPage/CommissionDetailsPage.types';
import { mapFormDataForSave } from 'modules/commission_terms/mapper';
import { commissionTerms } from 'routes/routePaths';
import { FIELDS, FILTER_NAMES } from 'modules/commission_terms/fields/types';

type Props = PageComponentProps;

const Index: React.FC<Props> = ({ history }) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [products, setProducts] = useState<Product[]>([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const { data } = await fetchProductsData();
        setProducts(data);
        setIsLoading(false);
      } catch (err) {
        console.error(err);
      }
    };

    fetchProducts();
  }, []);

  const onSubmit = async (data: FormModel) => {
    try {
      await postCommissionDetails(mapFormDataForSave(data));
      history.push(commissionTerms.index);
    } catch (err) {
      console.error(err);
    }
  };

  const initialValues: FormModel = {
    [FIELDS.COMMISSION_TERM_TYPE]: '',
    [FIELDS.COMMISSION_NAME]: '',
    [FIELDS.FEE]: null,
    [FIELDS.UPFRONT_FEE]: null,
    [FIELDS.ONGOING_FEE]: null,
    [FIELDS.FEE_END_DATE]: '',
    [FIELDS.PRODUCTS]: [],
    [FIELDS.FILTERS]: {
      [FILTER_NAMES.PRODUCT_TIER]: '',
      [FILTER_NAMES.PURPOSE_OF_THE_LOAN]: '',
      [FILTER_NAMES.PRODUCT_TYPE]: '',
      [FILTER_NAMES.FIXED_RATE_LENGTH]: '',
    },
  };

  return (
    <>
      {!isLoading && (
        <>
          <CommissionDetailsPage
            formData={initialValues}
            onSubmit={(data: FormModel) => onSubmit(data)}
            availableProducts={products}
          />
        </>
      )}
    </>
  );
};

export default Index;
